export default __webpack_public_path__ + "static/media/MAC3.c5ba193c.png";